import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/markdown-document-screen';
import { PROHIBITED_WORDS } from './Constants.ts';
import prohibitedWords from './fans-fund-me-prohibited-words-01032025.md';

function ProhibitedWords() {
  return (
    <Screen title={PROHIBITED_WORDS.TITLE_TEXT} subtitle={PROHIBITED_WORDS.SUBTITLE_TEXT} content={prohibitedWords} />
  );
}

export default ProhibitedWords;
